import callIcon from "@assets/images/call_icon.png";
import kitIcon from "@assets/images/kit_icon.png";
import medicinesIcon from "@assets/images/medicines_icon.png";
import travelIcon from "@assets/images/travel_icon.png";

export interface IHowItWorksCard {
  id: number;
  title: string;
  description: string;
  icon: string;
}

export const PROCESS_STEPS_CARDS: IHowItWorksCard[] = [
  {
    id: 1,
    title: "Doctor calls before arrival",
    description: "Assigned vet calls 15 min prior to understand the pet's condition.",
    icon: callIcon,
  },
  {
    id: 2,
    title: "Travel charges apply",
    description: "Based on distance from clinic. Show transparently before booking.",
    icon: travelIcon,
  },
  {
    id: 3,
    title: "Doctor carries kit & medicines",
    description: "Basic medicines and lab collection kits available on-site.",
    icon: kitIcon,
  },
  {
    id: 4,
    title: "Home medicine delivery",
    description: "Additional prescriptions arranged for home delivery within 2-4 hrs.",
    icon: medicinesIcon,
  },
];

export const AHS_REPEAT_PERSONA = "ahs_repeat";
export const AHS_BOOKING_LINK_ELIGIBLE_CITIES: string[] = ["noida", "ghaziabad", "faridabad","gurgaon","delhi","gurugram"];
